export const NotificationsEndpoints = {
  list: '/notification/list',
  export: '/notification/export',
  read: (id: string) => `/notification/read/${id}`,
  unread: (id: string) => `/notification/unread/${id}`,
  readAll: '/notification/read/all',
  delete: (id: string) => `/notification/del/${id}`,
  deleteBatch: '/notification/del/batch',
  readBatch: '/notification/read/batch',
  details: (id: string) => `/notification/${id}`,
  stream: '/notification/stream',
};
